const contentMessages: { [key: string]: any } = {};

const config = (window as any).__wccconfig ?? {};
_(contentMessages).extend(config.contentMessages);

export default contentMessages;